import classNames from 'classnames/bind';
import {
  DefaultValue,
  useRecommendParamsContext,
} from 'contexts/recommendParams';
import Tag from 'everywhere/common/filter/tag';
import styles from 'everywhere/index.module.scss';
import { FilterModalSection } from '../types';

const cx = classNames.bind(styles);

interface IProps {
  openFilter: (scrollElementId: FilterModalSection) => void;
}

export default function InlineFilter({ openFilter }: IProps) {
  const {
    recommendSearchParams: {
      continents,
      duration,
      fare,
      months,
      roundTripTime,
    },
  } = useRecommendParamsContext();
  const [
    [minDuration, maxDuration],
    [minFare, maxFare],
    [minRoundTripTime, maxRoundTripTime],
  ] = [duration, fare, roundTripTime].map(range =>
    range.split(',').map(str => +str),
  );
  return (
    <div className={cx('filters')}>
      <div className={cx('inner')}>
        <button
          type="button"
          className={cx('all')}
          aria-label="상세조건"
          onClick={() => openFilter(FilterModalSection.MODAL_TOP)}
        />
        <Tag
          clickCode="month"
          isChecked={months.size > 0}
          label="출발월"
          onClick={() => openFilter(FilterModalSection.DEPART_MONTH)}
        />
        <Tag
          clickCode="cont"
          isChecked={!!continents.size}
          label="지역"
          onClick={() => openFilter(FilterModalSection.REGION)}
        />
        <Tag
          clickCode="dur"
          isChecked={
            minDuration > DefaultValue.MIN_DURATION ||
            maxDuration < DefaultValue.MAX_DURATION
          }
          label="소요시간"
          onClick={() => openFilter(FilterModalSection.REQUIRED_TIME)}
        />
        <Tag
          clickCode="date"
          isChecked={
            minRoundTripTime > DefaultValue.MIN_ROUND_TRIP_TIME ||
            maxRoundTripTime < DefaultValue.MAX_ROUND_TRIP_TIME
          }
          label="여행기간"
          onClick={() => openFilter(FilterModalSection.TRAVEL_PERIOD)}
        />
        <Tag
          clickCode="price"
          isChecked={
            minFare > DefaultValue.MIN_FARE || maxFare < DefaultValue.MAX_FARE
          }
          label="가격"
          onClick={() => openFilter(FilterModalSection.PRICE)}
        />
      </div>
    </div>
  );
}
